<template>
  <div class="w-full min-h-screen grid grid-rows-[min-content_1fr]">
    <BaseHeader :user="authStore.user" v-bind="{ activeRoute }" v-on="{ logout }" />

    <div class="h-full w-full bg-gray-100 px-5 sm:px-32 py-8">
      <div class="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-[302px_1fr] gap-x-5">
        <CommonSidebar class="sticky top-[130px] hidden md:block" />

        <div class="w-full max-sm:col-span-full">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { CommonSidebar } from "@/components/Common";
import BaseHeader from "../components/Base/Header/BaseHeader.vue";
import { useAuthStore } from "@/modules/Authorization/store";

const authStore = useAuthStore();

const activeRoute = "/";

// Full document navigation, matching ExitModal: dropping every store on logout is what stops the
// next person on this device seeing the previous student's cached data. `auth` was not a route
// that exists, so this used to throw and leave the user sitting on the authenticated page.
const logout = () => {
  authStore.logout();
  window.location.replace("/sign-in");
};
</script>
